import lazyLoading from "./lazyLoading";

export default {
  name: "download-dbracuni",
  path: "/download/dbracuni",
  component: lazyLoading("download/dbracuni/dbracuni"),
  meta: {
    default: false,
    title: "DB Predračuni",
    class: "primary",
    show: false,
    iconClass: "fa fa-database",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/dbracuni.js